import React from 'react';
import { Link } from 'react-router-dom';
import { NumberInput } from './Inputs';
import { formatMoney } from '../formatMoney';

const MobileRow = ({ row, index, errors, isEditable, onChange }) => {
  return (
    <div className={`rounded-xl border border-slate-200 bg-white p-3 ${row.include === false ? 'opacity-70' : ''}`}>
      <div className="flex items-start justify-between gap-3">
        <label className="flex items-center gap-2 text-sm font-semibold text-slate-700">
          <input
            type="checkbox"
            checked={row.include === true}
            onChange={(e) => onChange(row.id, 'include', e.target.checked)}
            disabled={!isEditable}
            className="h-4 w-4 rounded border-slate-300 text-orange-600 focus:ring-orange-200 disabled:cursor-not-allowed"
            aria-label={`Include ${row.plate_no || `row ${index + 1}`}`}
          />
          {row.plate_no ? (
            <Link
              to={`/cars/${encodeURIComponent(row.plate_no)}`}
              className={`hover:underline ${row.include === false ? 'text-slate-400 line-through' : 'text-orange-600'}`}
            >
              {row.plate_no}
            </Link>
          ) : (
            <span className={row.include === false ? 'text-slate-400 line-through' : 'text-orange-600'}>-</span>
          )}
        </label>
        <div className="text-sm font-semibold text-right">{formatMoney(row.prorated_amount)}</div>
      </div>

      <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
        <div>
          <div className="text-xs uppercase tracking-wide text-slate-500">Allocation Date</div>
          <div className="mt-1 text-slate-700">{row.allocation_date || '-'}</div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-wide text-slate-500">Gross Amount</div>
          <div className="mt-1 text-slate-700">{formatMoney(row.gross_amount)}</div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-wide text-slate-500">Base Amount</div>
          <NumberInput
            value={row.base_amount}
            onChange={(e) => onChange(row.id, 'base_amount', e.target.value)}
            disabled={!isEditable || row.include === false}
            className="!mt-1 !h-10 !rounded-lg !text-center"
          />
        </div>

        <div>
          <div className="text-xs uppercase tracking-wide text-slate-500">Days Counted</div>
          <NumberInput
            step="1"
            value={row.days_counted}
            onChange={(e) => onChange(row.id, 'days_counted', e.target.value)}
            disabled={!isEditable || row.include === false}
            className="!mt-1 !h-10 !rounded-lg !text-center"
          />
        </div>

        <div className="col-span-2">
          <div className="text-xs uppercase tracking-wide text-slate-500">Discount</div>
          <NumberInput
            value={row.discount_amount}
            onChange={(e) => onChange(row.id, 'discount_amount', e.target.value)}
            disabled={!isEditable || row.include === false}
            className={`!mt-1 !h-10 !rounded-lg !text-center ${errors.discount_amount ? 'border-rose-400 focus:border-rose-400 focus:ring-rose-100' : ''}`}
          />
          {errors.discount_amount && <div className="mt-1 text-xs text-rose-600">{errors.discount_amount}</div>}
        </div>
      </div>

      <div className="mt-2 flex items-center justify-between text-sm font-semibold">
        <span className="text-slate-500">Net Amount</span>
        <span className="text-slate-900">{formatMoney(row.prorated_amount)}</span>
      </div>
    </div>
  );
};

export default MobileRow;
